module.exports = __webpack_public_path__ + "assets/img/drawItem5-1e292c2c.png";